import 'jquery';
import AddressAutocomplete from 'google-address-autocomplete';
import 'jquery-validation';
import 'jquery-validation/dist/additional-methods.js';
import {showButtonLoader, hideButtonLoader} from '../../util/helpers';

export default {
  init: function () {

    const options = {
      componentRestrictions: {country: "us"},
    };
    // Use a callback here to get the results
    new AddressAutocomplete("#inputStreetAddress", options, (results) => {

      const addressObject = results;

      jQuery("#address1").val(addressObject.streetNumber + " " + addressObject.streetName);
      jQuery("#city").val(addressObject.cityName);
      jQuery("#state").val(addressObject.stateAbbr);
      jQuery("#zip").val(addressObject.zipCode);

    });

    $.validator.addMethod("autoaddress", function () {

      if ($("#address1").val().length == 0 || $("#city").val().length == 0 || $("#state").val().length == 0) {
        return false;
      }

      return true;
    }, "Please choose a full address from dropdown");

    var accountAddressForm = $('#accountAddressForm');
    var submitButton = $('#wp-submit');

    submitButton.on('click', function (e) {
      e.preventDefault();
      showButtonLoader(submitButton);
      
      setTimeout(() => {
        var valid = accountAddressForm.valid();
        if (valid) {
          setTimeout(function () {
            accountAddressForm.submit();
          }, 1000);
        }else {
          hideButtonLoader(submitButton);
        }
      }, 1000);
    });

    accountAddressForm.validate({
      errorElement: "span",
      rules: {
        address: {
          required: true,
          autoaddress: true,
        },
        phone: {
          required: true,
          phoneUS: true,
        },
      },
      onkeyup: false,
      onfocusout: function (element) {
        var self = this;
        if (element.name === "address") {
          // wait for google maps response
          setTimeout(function () {
            self.element(element);
          }, 600);

        } else {
          self.element(element);
        }
      },
      messages: {
        address: {
          autoaddress: "Please choose a full address from dropdown",
        },
      },
      errorPlacement: function (error, element) {
        error.insertAfter(element);
      },
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/account/myaddress.js